import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { httpOptions, serviceConstants } from 'src/app/constants/service.constants';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(private http: HttpClient) { }
  jsonOptions: { responseType: 'json' | undefined, withCredentials: boolean | undefined } = { responseType: "json", withCredentials: true };

  getDashboardsDetails(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/Analytics/GetAnalyticsDashboardsDetails', obj, httpOptions)
  }

  getDashboardsDetailsID(ID: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/Analytics/GetAnalyticsDashboardsDetailsByID/'+ ID, httpOptions)
  }

  UpdateAnalyticsDashboardDetails(obj: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/Analytics/UpdateAnalyticsDashboardDetails', obj, httpOptions)
  }

  GetUserDashboards(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/Analytics/GetUserDashboards/', httpOptions)
  }

  InsertDataPost(url: string, formData: any): Observable<any> {
    return this.http.post((serviceConstants.apiURL + url), formData, httpOptions)
  }

  getData(url: string): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), httpOptions)
  }

  getDataById(url: string, Id :string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url + Id , httpOptions)
  }

  postOrgDetails(obj: OrgDetails): Observable<any>{
    return this.http.post(serviceConstants.apiURL + 'api/organization/SyncDashboards', obj, httpOptions)
  }

  refreshOrgDetails(obj: OrgDetails): Observable<any>{
    return this.http.post(serviceConstants.apiURL + 'api/organization/RefreshOrg', obj, httpOptions)
  }
  
  FetchUpdatedAnalytics(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/Analytics/IsAnalyticsUpdateEnabledWhileDashboardClick', httpOptions)
  }

}

export class OrgDetails{
  OrgId:string;
  OrgName:string;
  IST:boolean;
  EAP:boolean;
  GRANTS:boolean;
  IS_ORG_ACCOUNT_IN_LOGI:boolean;
}

